












import { Component, Vue, Prop } from 'vue-property-decorator';
import InjuryForm from '@/classes/InjuryForm';

@Component
export default class DetailsInjuryForm extends Vue {
    @Prop({default: new InjuryForm({})}) public item!: InjuryForm;
}
